// extracted by mini-css-extract-plugin
module.exports = {"btnContainer":"ComplaintFormSelector_btnContainer__3gD1F","btn":"ComplaintFormSelector_btn__gIyID"};